{
  "paymentLink": "https://nowpayments.io/payment/?iid=5484773255",
  "period": "LIFETIME",
  "badge": "-10% OFF",
  "price": "450",
  "styleType": "White",
  "isMostPopular": false,
  "title": "LIFETIME ACCESS",
  "descriptionList": [
    "Access to Richard Swing Channel",
    "Access to Richard Scalping Channel",
    "Access to Richard Altcoin Channel",
    "All signals can be fully automated",
    "Highly active support from me"
  ],
  "id": "3"
}